import {Roles} from '../types/users';

export function isCPMAdmin(authRole: Roles[]) { 
  if (authRole.includes('CPM_ADMIN')) return 'CPM_ADMIN';
};

